import { CATEGORIES, TID } from "@/lib/constants";

export default function CategoryPills({ value = "all", onChange }) {
  return (
    <div className="flex gap-2 overflow-x-auto no-scrollbar px-4 sm:px-6 py-3">
      {CATEGORIES.map((c) => {
        const active = c.key === value;
        return (
          <button
            key={c.key}
            type="button"
            onClick={() => onChange && onChange(c.key)}
            data-testid={active ? TID.feedFilterPillActive : TID.feedFilterPill}
            data-category={c.key}
            className={`shrink-0 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${active ? "bg-[#E85A2A] text-[#F8FAFC] border-[#E85A2A] shadow-[0_2px_8px_rgba(232,90,42,0.35)]" : "bg-[#1A2232] text-[#94A3B8] border-[#26334D] hover:bg-[#232E45] hover:text-[#F8FAFC]"}`}
            aria-pressed={active}
          >
            {c.label}
          </button>
        );
      })}
    </div>
  );
}
